"use strict";
/*
 * Created on 1. 11. 2018
 *
 * Copyright (c) 2018 Etnetera, a.s. All rights reserved.
 * Intended for internal use only.
 * http://www.etnetera.cz
 */

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
      r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
      d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
    if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  }
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};

var __metadata = this && this.__metadata || function (k, v) {
  if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};

var __param = this && this.__param || function (paramIndex, decorator) {
  return function (target, key) {
    decorator(target, key, paramIndex);
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var typescript_ioc_1 = require("@logio/typescript-ioc");

var ValidationResultConverter_1 = require("../../core/model/errors/conversions/ValidationResultConverter");

var ValidationResult_1 = require("../../core/model/errors/ValidationResult");

var utils_1 = require("../../core/utils");

var FinalProductPrice_1 = require("../model/FinalProductPrice");

var FinalProductPriceConverter_1 = require("./FinalProductPriceConverter");
/**
 * @author Radek Beran
 */


var FinalProductPriceConverterImpl =
/*#__PURE__*/
function (_FinalProductPriceCon) {
  _inherits(FinalProductPriceConverterImpl, _FinalProductPriceCon);

  function FinalProductPriceConverterImpl(validationResultConverter) {
    var _this;

    _classCallCheck(this, FinalProductPriceConverterImpl);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(FinalProductPriceConverterImpl).call(this));
    _this.validationResultConverter = validationResultConverter;
    return _this;
  }
  /**
   * @inheritDoc
   */


  _createClass(FinalProductPriceConverterImpl, [{
    key: "toObject",
    value: function toObject(source, conversions) {
      return new FinalProductPrice_1.FinalProductPrice(utils_1.Utils.isValueMissing(source.priceZoneId) || source.priceZoneId === utils_1.Utils.VOID_ID ? utils_1.Utils.VOID_ID : FinalProductPrice_1.FinalProductPrice.schema.priceZoneId.valueOf(conversions.toClassReferenceId(source.priceZoneId)), FinalProductPrice_1.FinalProductPrice.schema.priceType.valueOfField(source), FinalProductPrice_1.FinalProductPrice.schema.value.valueOf(conversions.toBigNumber(source.value)), utils_1.Utils.isValueMissing(source.valueRounded) ? null : FinalProductPrice_1.FinalProductPrice.schema.valueRounded.valueOf(conversions.toBigNumber(source.valueRounded)), utils_1.Utils.isValueMissing(source.vatRate) ? null : FinalProductPrice_1.FinalProductPrice.schema.vatRate.valueOf(conversions.toBigNumber(source.vatRate)), utils_1.Utils.isValueMissing(source.lastExportedValue) ? null : FinalProductPrice_1.FinalProductPrice.schema.lastExportedValue.valueOf(conversions.toBigNumber(source.lastExportedValue)), FinalProductPrice_1.FinalProductPrice.schema.lastExportedValidFrom.valueOfField(source), !utils_1.Utils.isValueMissing(source.forecast) ? FinalProductPrice_1.FinalProductPrice.schema.forecast.valueOf(conversions.toBigNumber(source.forecast)) : null, FinalProductPrice_1.FinalProductPrice.schema.validFrom.valueOfField(source), FinalProductPrice_1.FinalProductPrice.schema.validTo.valueOfField(source), FinalProductPrice_1.FinalProductPrice.schema.originalValidTo.valueOfField(source), FinalProductPrice_1.FinalProductPrice.schema.changedByUserId.valueOf(source.changedByUserId), FinalProductPrice_1.FinalProductPrice.schema.changedByUserName.valueOf(source.changedByUserName), FinalProductPrice_1.FinalProductPrice.schema.changeDate.valueOfField(source), utils_1.Utils.isValueMissing(source.validationResult) ? ValidationResult_1.ValidationResult.EMPTY : this.validationResultConverter.toObject(source.validationResult, conversions));
    }
    /**
     * @inheritDoc
     */

  }, {
    key: "toDocument",
    value: function toDocument(source, conversions) {
      var result = {};
      Object.assign(result, {
        priceZoneId: source.priceZoneId === utils_1.Utils.VOID_ID ? null : conversions.toDocumentReferenceId(source.priceZoneId),
        priceType: source.priceType,
        value: conversions.fromBigNumber(source.value),
        valueRounded: source.valueRounded !== null ? conversions.fromBigNumber(source.valueRounded) : null,
        vatRate: source.vatRate !== null ? conversions.fromBigNumber(source.vatRate) : null,
        lastExportedValue: source.lastExportedValue !== null ? conversions.fromBigNumber(source.lastExportedValue) : null,
        lastExportedValidFrom: source.lastExportedValidFrom !== null ? conversions.fromDate(source.lastExportedValidFrom) : null,
        forecast: source.forecast !== null ? conversions.fromBigNumber(source.forecast) : null,
        validFrom: conversions.fromDate(source.validFrom),
        validTo: source.validTo !== null ? conversions.fromDate(source.validTo) : null,
        originalValidTo: source.originalValidTo !== null ? conversions.fromDate(source.originalValidTo) : null,
        changedByUserId: source.changedByUserId,
        changedByUserName: source.changedByUserName,
        changeDate: !utils_1.Utils.isValueMissing(source.changeDate) ? conversions.fromDate(source.changeDate) : null,
        validationResult: this.validationResultConverter.toDocument(source.validationResult, conversions)
      });
      return result;
    }
  }]);

  return FinalProductPriceConverterImpl;
}(FinalProductPriceConverter_1.FinalProductPriceConverter);

FinalProductPriceConverterImpl = __decorate([__param(0, typescript_ioc_1.Inject), __metadata("design:paramtypes", [ValidationResultConverter_1.ValidationResultConverter])], FinalProductPriceConverterImpl);
exports.FinalProductPriceConverterImpl = FinalProductPriceConverterImpl;